import CustomerSearchValue from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType    from "../../../domain/customer/criteria/CustomerSortType";
import CustomerRepository  from "../../../domain/customer/CustomerRepository";
import CurrentPage         from "../../../domain/fundamentals/pagination/CurrentPage";
import CustomerDataSource  from "../../../infrastructure/datasource/customer/CustomerDataSource";
import GetCustomers        from "./GetCustomers";

class GetCustomersPage {
  constructor(
    private readonly dispatch,
    private readonly customerRepository: CustomerRepository = new CustomerDataSource(dispatch),
    private readonly getCustomers: GetCustomers = new GetCustomers(dispatch),
  ) {
  }

  public execute(currentPage: CurrentPage, search: CustomerSearchValue, sortType: CustomerSortType) {
    this.customerRepository.setCurrentPage(currentPage);
    this.getCustomers.execute(currentPage, search, sortType);
  }
}

export default GetCustomersPage;
